import client from './client';

export const getSwitchUsers = () => client().get('/auth/switch');

export const createSwitchUsersApi = data => client().post('/auth/switch', data);
